import React, { Suspense } from "react";
import { TeamFeatureItem } from "./TeamFeatureItem";
import { graphql, useFragment } from "react-relay";
import { useIntlTokens } from "../../../../../components/mobile/useIntlTokens";
import { AHIcon } from "arkh";
import { IconLayout } from "./IconLayout";
import { TeamFeatureBarProductDateTrackerItem_productDateTrackerTeamFeature$key } from "./__generated__/TeamFeatureBarProductDateTrackerItem_productDateTrackerTeamFeature.graphql";
export function TeamFeatureBarProductDateTrackerItem(props: {
  productDateTrackerFeature: TeamFeatureBarProductDateTrackerItem_productDateTrackerTeamFeature$key;
  onPress: () => void;

  isGrid: boolean;
}) {
  const intl_tokens = useIntlTokens();

  return (
    <Suspense
      fallback={
        <TeamFeatureItem
          icon={<AHIcon type="tag" size="medium" />}
          title={intl_tokens.ExpireDates}
          isGrid={props.isGrid}
          onPress={() => {
            props.onPress();
          }}
        />
      }
    >
      <InnerTeamFeatureBarProductDateTrackerItem {...props} />
    </Suspense>
  );
}

function InnerTeamFeatureBarProductDateTrackerItem(props: {
  productDateTrackerFeature: TeamFeatureBarProductDateTrackerItem_productDateTrackerTeamFeature$key;
  onPress: () => void;

  isGrid: boolean;
}) {
  const productFeature = useFragment(
    graphql`
      fragment TeamFeatureBarProductDateTrackerItem_productDateTrackerTeamFeature on ProductDateTrackerTeamFeature {
        id
        hasExpiredBatches
        hasPendingActions
      }
    `,
    props.productDateTrackerFeature
  );

  const intl_tokens = useIntlTokens();

  const icons = [];
  if (productFeature.hasPendingActions) {
    icons.push(<AHIcon type="clock" size="medium" color="primary" />);
  }
  if (productFeature.hasExpiredBatches) {
    icons.push(<AHIcon type="flag" size="medium" color="negative" />);
  }

  return (
    <TeamFeatureItem
      icon={<AHIcon type="tag" size="medium" />}
      title={intl_tokens.ExpireDates}
      isGrid={props.isGrid}
      right={<IconLayout icons={icons} />}
      onPress={() => {
        props.onPress();
      }}
    />
  );
}
